import { TFirmwareAction, FirmwareActionTypes } from './firmwareActions';
import { IFirmwareState } from './firmwareContext';

export const firmwareReducer = (state: IFirmwareState, action: TFirmwareAction): IFirmwareState => {
	switch (action.type) {
		case FirmwareActionTypes.SET_FIRMWARE:
			return {
				...state,
				firmware: action.payload.firmware,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case FirmwareActionTypes.CHANGE_SEARCH_STRING:
			return {
				...state,
				searchString: action.payload.searchString,
				currentPage: 1,
			};
		case FirmwareActionTypes.CHANGE_TYPE_FIRMWARE:
			return {
				...state,
				IDSelectedTypeFirmware: action.payload.IDSelectedTypeFirmware,
				currentPage: 1,
			};
		case FirmwareActionTypes.TOGGLE_UNASSIGNED_FIRMWARE:
			return {
				...state,
				isUnassignedFirmware: !state.isUnassignedFirmware,
				currentPage: 1,
			};
		case FirmwareActionTypes.SET_SORT_BY:
			return {
				...state,
				sortBy: action.payload.sortBy,
				currentPage: 1,
			};
		case FirmwareActionTypes.SET_COUNT_OF_ITEMS:
			return {
				...state,
				countOfItems: action.payload.countOfItems,
				currentPage: 1,
			};
		case FirmwareActionTypes.CHANGE_CURRENT_PAGE:
			return {
				...state,
				currentPage: action.payload.currentPage,
			};
		case FirmwareActionTypes.SET_ID_FOR_DELETION:
			return {
				...state,
				IDForDeletion: action.payload.IDForDeletion,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case FirmwareActionTypes.RESET_SELECTED_CONTROLS:
			return {
				...state,
				searchString: '',
				IDSelectedTypeFirmware: null,
				currentPage: 1,
				isUnassignedFirmware: false,
			};
		case FirmwareActionTypes.SET_FILTERS_FROM_QUERY_STRING:
			return {
				...state,
				...action.payload.filters,
			};
		case FirmwareActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case FirmwareActionTypes.SHOW_ERROR_MODAL_WITH_INFO:
			return {
				...state,
				errorResponseData: action.payload.errorResponseData,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		default:
			return state;
	}
};
